import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

import { rootSiteSelector, siteFromRootSiteSelector } from 'selectors/root-site';
import { isAdminPath } from 'utils/url';
import { isBlockAvailableForSite } from 'utils/premium-service';

const usePremiumServiceEnabled = (serviceName) => useAllPremiumServicesEnabled([serviceName]);

export const useAllPremiumServicesEnabled = (serviceNames) => {
  const { siteSlug } = useParams();
  const siteData = useSelector(siteSlug ? siteFromRootSiteSelector(siteSlug) : rootSiteSelector);

  if (isAdminPath() || isEmpty(serviceNames)) return true;

  return isBlockAvailableForSite({ requiredPremiumServices: serviceNames }, siteData);
};

export default usePremiumServiceEnabled;
